export default {
    install(Vue) {
        function toUpperCase(e) {
            const el = e.target;

            // Ignorar elementos con data-no-uppercase
            if (el.hasAttribute('data-no-uppercase')) return;

            // Validar existencia y tipo de elemento
            if (
                !el ||
                (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA')
            ) return;

            // Ignorar tipos de input que no admiten texto seleccionable
            const invalidTypes = ['file', 'checkbox', 'radio', 'date', 'datetime-local', 'month', 'week', 'time', 'color', 'number'];
            if (el.tagName === 'INPUT' && invalidTypes.includes(el.type)) return;

            // Aplicar mayúsculas
            const upper = el.value.toLocaleUpperCase('es');
            if (upper !== el.value) {
                const { selectionStart, selectionEnd } = el;
                el.value = upper;
                el.dispatchEvent(new Event('input', { bubbles: true }));

                // Solo restablecer selección si el método existe
                if (typeof el.setSelectionRange === 'function') {
                    el.setSelectionRange(selectionStart, selectionEnd);
                }
            }
        }

        document.addEventListener('input', toUpperCase, true);
    }
}
